const blogsData = [
    {
        id: 1,
        title: 'Boost your conversion rate',
        category: 'Desktop',
        img: 'https://cutt.ly/YXNpwA3',
        author: 'Learn with sumit',
        authorImg: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        date: '11 Jul, 2022',
        publishedTime: '6 min read'
    },
    {
        id: 2,
        title: 'How to use search engine optimization to drive sales',
        category: 'Laptop',
        img: 'https://cutt.ly/YXNpwA3',
        author: 'Miraz',
        authorImg: 'https://mirazhs.xyz/assets/img/custom_profile.png',
        date: '08 Feb, 2022',
        publishedTime: '16 min read'
    },
    {
        id: 3,
        title: 'Improve your customer experience',
        category: 'Desktop',
        img: 'https://cutt.ly/KXNpgYg',
        author: 'Learn with sumit',
        authorImg: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        date: '16 Jul, 2022',
        publishedTime: ' 37min read'
    },
    {
        id: 4,
        title: 'The Cheap Desktop Computers We’d Buy, and How to Shop for One',
        category: 'Desktop',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Mark',
        authorImg: 'https://cutt.ly/zXNiFuw',
        date: '19 Jul, 2022',
        publishedTime: '29 min read'
    },
    {
        id: 5,
        title: 'How to Learn to Use a Laptop Computer',
        category: 'Camera',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Miraz',
        authorImg: 'https://mirazhs.xyz/assets/img/custom_profile.png',
        date: '13 Jul, 2022',
        publishedTime: '10 min read'
    },
    {
        id: 6,
        title: ' how to use a webcam for live streaming',
        category: 'Webcamps',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Mark',
        authorImg: 'https://cutt.ly/zXNiFuw',
        date: '21 Jul, 2022',
        publishedTime: '15 min read'
    },
    {
        id: 7,
        title: 'The Best Monitors',
        category: 'Desktop',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Jhon',
        authorImg: 'https://cutt.ly/FXNoGca',
        date: '5 Jul, 2022',
        publishedTime: '19 min read'
    },
    {
        id: 8,
        title: 'WHY A GOOD CAMERA IS ESSENTIAL FOR BLOGGING',
        category: 'Camera',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Mark',
        authorImg: 'https://cutt.ly/zXNiFuw',
        date: '25 Jul, 2022',
        publishedTime: '20 min read'
    },
    {
        id: 9,
        title: 'How to Take Good Pictures With Your Mobile Device',
        category: 'Camera',
        img: 'https://cutt.ly/eXHCrJb',
        author: 'Jhon',
        authorImg: 'https://cutt.ly/FXNoGca',
        date: '15 Jul, 2022',
        publishedTime: '10 min read'
    }
];

export default blogsData;
